/**
 * Runtime and build-time settings for the interview API.
 * The production URL can be changed in public/config.js after upload.
 */

export const getApiBaseUrl = () => {
  const runtimeUrl = typeof window !== 'undefined' ? window.INTERVIEW_API_BASE_URL : '';
  const url = (runtimeUrl || process.env.REACT_APP_API_BASE_URL || '').trim();
  return url.replace(/\/$/, '');
};

export const hasApiBaseUrl = () => {
  return !!getApiBaseUrl();
};
